<template>
    <v-card v-if="myData != null" flat>
        <v-card-text>
            <v-row v-if="myData.prace.length == 0">
                <p>Nemáš žiadne práce na prezentovanie</p>
            </v-row>
            <v-row v-for="praca,index in myData.prace" :key="index">
                <v-col cols=12>
                    <h3>
                    <span v-if="praca.archivovane==1"><v-icon title="Archivovaná">handshake</v-icon> &nbsp;&nbsp;</span>
                    {{praca.nazov}} - ({{praca.skolitel}}) {{praca.st_program}}-{{praca.typ}} {{praca.rok_vypisania}}</h3>
                </v-col>
                <v-row v-if="praca.terminy.length > 0 && praca.archivovane==0">                    
                    <v-col cols=12>
                     <v-card variant="outlined">
                        <v-card-title>
                            Termíny prezentácie
                        </v-card-title>
                        <v-card-text>
                            <br>
                            <v-row v-for="termin,index in praca.terminy" :key="index" style="margin-left:10px">
                                <v-col cols=12>
                                <v-card variant="outlined">
                                    <v-card-title>
                                        <v-row style="margin:5px">
                                            ({{termin.pocet_miest-termin.volne}} / {{termin.pocet_miest}})
                                            &nbsp;&nbsp;
                                            <b>{{termin.termin}}</b>
                                            <v-spacer></v-spacer>
                                            <v-icon v-if="praca.termin_id == termin.id" large color="green">done</v-icon>
                                            <v-spacer></v-spacer>
                                            <v-icon v-if="termin.volne>0" title="Zapíš ma" style="margin-right:10px;color:green" @click="zapisMa(termin.id, praca.id)">person_add</v-icon>
                                            <v-icon v-if="praca.termin_id == termin.id" title="Odhlás ma" style="margin-right:10px; color:red" @click="odhlasMa(termin.id, praca.id)">person_remove</v-icon>
                                            <v-icon title="Ukáž zoznam" style="margin-right:10px" @click="showList(termin.id)">groups</v-icon>
                                        </v-row>
                                    </v-card-title>
                                    <v-row v-if="termin.id == rozbalitTermin">
                                        <v-col cols=12 v-if="termin.id == rozbalitTermin">
                                            <v-card style="background-color:#E8F5E9" variant="outlined">
                                                <v-card-title>
                                                    Zoznam prihlásených
                                                    <v-icon class="btn-close" @click="rozbalitTermin=-1">close</v-icon>
                                                </v-card-title>
                                                <v-card-text v-for="clovek,index in ludiaNaTermine" :key="index" style="margin-bottom:-15px">
                                                    {{clovek.nickname}} - {{clovek.nazov}}
                                                </v-card-text>
                                                <br>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-card>
                                </v-col>
                            </v-row>
                        </v-card-text>
                     </v-card>
                    </v-col>
                </v-row>
            </v-row>
        </v-card-text>
    </v-card>    
</template>

<script>
import axios from '../../axios-auth.js'

export default {
    data() {
        return {
            myData : null,
            rozbalitTermin: -1,
            ludiaNaTermine: null
        }
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            this.$store.commit('setFeedback', null)
            this.getUserPresData()
        },
        getUserPresData() {
            axios.get('/get-presn-user-data', this.$store.getters.getAxiosConfig)
            .then((res) => {
                this.myData = res.data   
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                } 
                if (this.rozbalitTermin > 0) {
                    this.showList(this.rozbalitTermin)
                }
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
        },
        showList(_id) {
            axios.get('/get-users-on-term/'+_id, this.$store.getters.getAxiosConfig)
            .then((res) => {
                this.ludiaNaTermine = res.data.list    
                this.rozbalitTermin = _id            
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                } 
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
        },
        zapisMa(_terminid, _pracaid) {
            const _data = {
                termin_id: _terminid,
                praca_id: _pracaid
            }
            axios.post('/set-users-to-term', _data, this.$store.getters.getAxiosConfig)
            .then((res) => {
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                } else {
                    this.initData()
                }
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
        },
        odhlasMa(_terminid, _pracaid) {
            const _data = {
                termin_id: _terminid,
                praca_id: _pracaid
            }
            axios.post('/remove-users-from-term', _data, this.$store.getters.getAxiosConfig)
            .then((res) => {
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                } else {
                    this.initData()
                }
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
        }
    }
}
</script>

<style>
    .btn-close {
    position: absolute !important;
    top: 4px;
    right: 4px;
    z-index: 2;
    }
</style>